const LINGUAL_NINJA_HOST = "lingual-ninja.com";
const USER_ID_PARAM = "x";

export interface ExternalLinkAttributes {
    href: string | undefined;
    rel: string;
}

export function getExternalLinkAttributes(
    href: string | undefined,
    nofollow: boolean,
    userId?: number,
    specifiedRel?: string
): ExternalLinkAttributes {
    const defaultRel = nofollow
        ? "nofollow noopener noreferrer"
        : "noopener noreferrer";

    if (!href) {
        return {
            href,
            rel: specifiedRel ?? defaultRel,
        };
    }

    try {
        const url = new URL(href);
        if (!isLingualNinjaHost(url.hostname)) {
            return {
                href,
                rel: specifiedRel ?? defaultRel,
            };
        }

        if (userId != null) {
            url.searchParams.set(USER_ID_PARAM, userId.toString());
        } else {
            url.searchParams.delete(USER_ID_PARAM);
        }

        return {
            href: url.toString(),
            rel: getLingualNinjaRel(specifiedRel),
        };
    } catch {
        return {
            href,
            rel: specifiedRel ?? defaultRel,
        };
    }
}

function isLingualNinjaHost(hostname: string) {
    return (
        hostname === LINGUAL_NINJA_HOST ||
        hostname.endsWith(`.${LINGUAL_NINJA_HOST}`)
    );
}

function getLingualNinjaRel(specifiedRel?: string) {
    const relValues = (specifiedRel ?? "")
        .split(/\s+/)
        .filter(
            value =>
                value &&
                value.toLowerCase() !== "nofollow" &&
                value.toLowerCase() !== "noreferrer" &&
                value.toLowerCase() !== "noopener"
        );

    return ["noopener", ...relValues].join(" ");
}
